<template>
    <div class="modal-mask" >
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h3>تحديث جديد متوفر</h3>
          </div>
          <div class="modal-body">
            <p>هناك تحديث جديد. سيتم تحديث الموقع تلقائيًا بعد 3 ثوانٍ.</p>
          </div>
          <div class="modal-footer">
            <button class="modal-default-button" @click="reloadNow">
              تحديث الآن
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "UpdateModal",
    props: {
      // إذا كنت تمرر visible كـ prop، يمكنك استخدامه هنا؛ 
      // لكن بما أنك تستخدم v-if من المكون الأب فلا تحتاج لخاصية visible داخل الـ modal.
      // إذا أردت استخدام prop، تأكد من تمريره من المكون الأب.
    },
    methods: {
      reloadNow() {
        window.location.reload();
      },
    },
    mounted() {
      console.log("Modal mounted – it should be visible now.");
      setTimeout(() => {
        this.reloadNow();
      }, 3000);
    },
  };
  </script>
  
  <style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .modal-container {
    width: 300px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    padding: 20px;
    text-align: center;
  }
  .modal-header h3 {
    margin: 0;
  }
  .modal-body {
    margin: 20px 0;
  }
  .modal-footer {
    text-align: right;
  }
  .modal-default-button {
    background-color: #42b983;
    border: none;
    color: white;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
  z-index: 10;

  }
  </style>
  


// WEBPACK FOOTER //
// src/components/UpdateModal.vue